/*
 * @Author: Gavin Chan
 * @Date: 2021-11-17 15:22:51
 * @LastEditors : Please set LastEditors
 * @LastEditTime: 2025-06-16 11:02:11
 * @FilePath     : \examinee_web\src\http\api\message.ts
 * @Descriptions: 定义消息相关接口
 */
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import $http from "@/utils/request";
const messageAPI = `${ServiceGateWay.MESSAGE}`;
const newMessageAPI = `${ServiceGateWay.NOTIFICATIONMESSAGE}`;
const ANNOUNCEMENTEXAMINEESERVICE = `${ServiceGateWay.ANNOUNCEMENTEXAMINEESERVICE}`;

// 考生站内消息
const examineeMessageAPI = `${messageAPI}/examinee/message`;
const newExamineeMessageAPI = `${newMessageAPI}/examinee/message`;

// 站内消息
export const InternalMessage = {
  GET: {
    getNewMessageList(params: any) {
      return $http({
        url: `${newExamineeMessageAPI}`,
        params,
        options: {
          tenantId: undefined,
        },
      });
    },
  },
  POST: {},
  PATCH: {},
  DELETE: {},
};

export const AnnouncementExamineeService = {
  GET: {
    getAnnouncementExamineeServiceList(params: any) {
      return $http({
        url: `${ANNOUNCEMENTEXAMINEESERVICE}/AnnouncementExamineeService`,
        params,
        options: {
          tenantId: undefined,
        },
      });
    },
    getIdAnnouncementExamineeService(id: string) {
      return $http({
        url: `${ANNOUNCEMENTEXAMINEESERVICE}/AnnouncementExamineeService/${id}`,
        options: {
          tenantId: undefined,
        },
      });
    },
  },
};

export default { InternalMessage, AnnouncementExamineeService };
